/* global ASSET_SERVER_URL */

import compact from "lodash/compact";
import escapeRegExp from "lodash/escapeRegExp";

export const assetUrl = (id, filename, params = []) => {
  if (id.match(new RegExp(`${escapeRegExp(filename)}$`)) && !params.length) filename = null;
  return `${ASSET_SERVER_URL}/files/${compact([id, ...params, encodeURIComponent(filename || "")]).join("/")}`;
};

export const getHeight = (width, aspectRatio = 1) => parseInt(Math.ceil(parseFloat(width) / parseFloat(aspectRatio)), 10);
